'use client'

import { Button } from '@lune-fe/lune-ui-lib'
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight'
import { FC } from 'react'

import BlueBox from '@/components/BlueBox'
import useDevice from '@/hooks/useDevice'

export enum Sector {
    LOGISTICS = 'logistics',
    PROCUREMENT = 'procurement',
    PAYMENTS = 'payments',
    FINANCE = 'finance',
}

const RequestDemo: FC<{ sector?: Sector }> = ({ sector }) => {
    const { smScreen } = useDevice()

    return (
        <BlueBox
            text={`Build a climate positive legacy ${sector ? 'in ' + sector : ''}`}
            rightSide={
                <Button
                    href="/request-a-demo"
                    sx={{ width: smScreen ? '100%' : 'auto' }}
                    variant={'contained'}
                    leftIcon={<ArrowCircleRightIcon />}
                >
                    Request a demo
                </Button>
            }
        />
    )
}

export default RequestDemo
